<!-- Последние уведомления текущей компании без изменения полной страницы списка. -->
<template>
  <section
    id="notification-popup"
    class="notification-popup"
    role="dialog"
    aria-label="Последние уведомления"
    tabindex="-1"
  >
    <div class="notification-popup__body">
      <List compact @open-history="$emit('close')" />
    </div>
    <footer class="notification-popup__footer">
      <BaseTooltip ref="readAllTooltip" class="notification-popup__feedback" />
      <base-button
        v-if="hasUnread || store.readingAll"
        variant="primary"
        icon="check"
        :disabled="store.isReading || store.dataIsLoading || store.loadFailed || !hasUnread"
        @click="markAllRead"
      >
        {{ store.readingAll ? 'Отмечаем…' : 'Прочитать все' }}
      </base-button>
      <router-link :to="{ name: 'Notifications' }" @click="$emit('close')">
        Все уведомления
      </router-link>
    </footer>
  </section>
</template>

<script>
import List from "@/components/Notification/List.vue";
import { useNotificationPopupStore } from "@/stores/notificationItemsStore";
import { useNotificationCounterStore } from "@/stores/notificationCounterStore";
import { createNotificationFocusRestorer } from "@/utils/notification/focusUtils";

export default {
  name: "NotificationPopup",
  components: { List },
  emits: ["close"],
  computed: {
    store() {
      return useNotificationPopupStore();
    },
    hasUnread() {
      return useNotificationCounterStore().unreadCount > 0 || this.store.items.some((item) => !item.read_at);
    },
  },
  methods: {
    async markAllRead(event) {
      const anchor = event.currentTarget.getBoundingClientRect();
      const restoreFocus = createNotificationFocusRestorer(event.currentTarget, this.$el);
      const saved = await this.store.markRead();
      await this.$nextTick();
      restoreFocus();
      if (saved) {
        useNotificationCounterStore().fetchCount();
        this.$refs.readAllTooltip?.showFeedback("Уведомления прочитаны", anchor);
      }
    },
  },
};
</script>

<style scoped>
.notification-popup {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 1100;
  width: min(420px, calc(100vw - 32px));
  max-height: min(560px, calc(100dvh - 120px));
  display: flex;
  flex-direction: column;
  border: 1px solid var(--color-grey);
  border-radius: 12px;
  background: var(--color-light);
  box-shadow: 0 8px 24px color-mix(in srgb, var(--color-dark) 15%, transparent);
  color: var(--color-dark);
  text-align: left;
}

.notification-popup__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 16px;
  flex-shrink: 0;
}

.notification-popup__feedback {
  position: absolute;
}

/* Мостик через отступ сохраняет hover при переходе от колокольчика к списку. */
.notification-popup::before {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  height: 24px;
}

.notification-popup__body {
  padding: 8px 12px 0;
  overflow-y: auto;
  min-height: 0;
  overscroll-behavior: contain;
}

.notification-popup__footer a {
  color: color-mix(in srgb, var(--color-dark) 65%, var(--color-light));
  font-size: 13px;
  text-underline-offset: 3px;
}

.notification-popup__footer a:hover {
  color: var(--color-dark);
}
</style>
